import { createStore } from 'vuex'
import { supabase } from '@/lib/axios'

export default createStore({
  state: {
    user: null,
    otpList: [],
    lastCreatedTime: null,
    isLoading: false,
    error: null
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    getUser: (state) => state.user,
    getOtpList: (state) => state.otpList,
    getLastCreatedTime: (state) => state.lastCreatedTime,
    getIsLoading: (state) => state.isLoading,
    getError: (state) => state.error
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_OTP_LIST(state, { otpList, createdTime }) {
      state.otpList = otpList;
      state.lastCreatedTime = createdTime;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  actions: {
    // Auth state değişikliklerini dinlemek için
    subscribeToAuthChanges({ commit }) {
      return supabase.auth.onAuthStateChange((event, session) => {
        if (event === 'SIGNED_IN' && session) {
          commit('SET_USER', session.user);
        } else if (event === 'SIGNED_OUT') {
          commit('SET_USER', null);
        }
      });
    },
    
    // Basit session kontrolü için
    async fetchSession({ commit }) {
      try {
        commit('SET_LOADING', true);
        const { data, error } = await supabase.auth.getSession();
        if (error) throw error;
        commit('SET_USER', data.session?.user || null);
        return { data, error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { data: { user: null }, error };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // Login - email ve şifre ile
    async login({ commit }, { email, password }) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const { data, error } = await supabase.auth.signInWithPassword({
          email,
          password
        });
        
        if (error) throw error;
        
        commit('SET_USER', data.user);
        return { data, error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { data: null, error };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // Magic Link ile giriş
    async loginWithMagicLink({ commit }, { email, redirectTo }) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const { data, error } = await supabase.auth.signInWithOtp({
          email,
          options: {
            emailRedirectTo: redirectTo || `${window.location.origin}/login`
          }
        });
        
        if (error) throw error;
        
        return { data, error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { data: null, error };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // Kullanıcı kaydı
    async register({ commit }, { email, password }) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const { data, error } = await supabase.auth.signUp({
          email,
          password,
          options: {
            emailRedirectTo: `${window.location.origin}/login`
          }
        });
        
        if (error) throw error;
        
        return { data, error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { data: null, error };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // Logout
    async logout({ commit }) {
      try {
        commit('SET_LOADING', true);
        
        const { error } = await supabase.auth.signOut();
        
        if (error) throw error;
        
        commit('SET_USER', null);
        return { error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { error };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // Şifre sıfırlama
    async resetPassword({ commit }, { email, redirectTo }) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: redirectTo || `${window.location.origin}/update-password`
        });
        
        if (error) throw error;
        
        return { data, error: null };
      } catch (error) {
        commit('SET_ERROR', error.message);
        return { data: null, error };
      } finally {
        commit('SET_LOADING', false);
      }
    }
  }
})
